import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { orderApi } from "../api/orderApi";
import Message from "../components/Message";

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [notice, setNotice] = useState(null);
  const [searchId, setSearchId] = useState("");
  const [searchDate, setSearchDate] = useState("");

  useEffect(() => {
    orderApi.getOrders().then((data) => {
      setOrders(data.orders || data.items || []);
    }).catch((error) => setNotice({ type: "error", text: error.message }));
  }, []);

  const filteredOrders = orders.filter((order) => {
    const matchesId = searchId === "" || order.order_number.toLowerCase().includes(searchId.toLowerCase());
    const matchesDate = searchDate === "" || new Date(order.created_at).toLocaleDateString() === new Date(searchDate).toLocaleDateString();
    return matchesId && matchesDate;
  });

  return (
    <div className="orders-container">
      <div className="container">
        <h1 className="page-title">My Orders</h1>
        <div className="orders-nav">
          <Link to="/account-settings" className="btn btn-secondary">Account Settings</Link>
          <Link to="/payment-methods" className="btn btn-secondary" style={{ marginLeft: 12 }}>Payment Methods</Link>
        </div>
        <Message notice={notice} />

        <div className="orders-search" style={{ display: "flex", gap: 12, marginBottom: 24 }}>
          <input
            type="text"
            placeholder="Search by order ID..."
            value={searchId}
            onChange={(e) => setSearchId(e.target.value)}
            className="form-control"
          />
          <input
            type="date"
            value={searchDate}
            onChange={(e) => setSearchDate(e.target.value)}
            className="form-control"
          />
          {(searchId || searchDate) && (
            <button className="btn btn-secondary" onClick={() => { setSearchId(""); setSearchDate(""); }}>Clear</button>
          )}
        </div>

        {filteredOrders.length > 0 ? (
          <div className="orders-list">
            {filteredOrders.map((order) => (
              <div className="order-card" key={order.id}>
                <div className="order-header">
                  <div className="order-info">
                    <h3>Order #{order.order_number}</h3>
                    <p className="order-date">{new Date(order.created_at).toLocaleDateString()}</p>
                  </div>
                  <div className="order-status">
                    <span className={`status-badge status-${order.status}`}>{String(order.status).toUpperCase()}</span>
                  </div>
                </div>

                <div className="order-content">
                  <div className="order-items">
                    <h4>Items:</h4>
                    <ul>
                      {(order.items || []).map((item, index) => (
                        <li key={index}>
                          {item.product_name || item.product?.name} x{item.quantity} - $
                          {(Number(item.price) * Number(item.quantity)).toFixed(2)}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="order-details">
                    <p><strong>Total:</strong> ${Number(order.total_price).toFixed(2)}</p>
                    <p><strong>Delivery to:</strong> {order.delivery_address}</p>
                    {order.estimated_arrival ? (
                      <p><strong>Estimated Arrival:</strong> {new Date(order.estimated_arrival).toLocaleDateString()}</p>
                    ) : null}
                  </div>
                </div>

                <div className="order-actions">
                  <Link to={`/order-tracking/${order.id}`} className="btn btn-sm btn-primary">Track Order</Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            {orders.length > 0
              ? <p>No orders match your search.</p>
              : <><p>You haven&apos;t placed any orders yet.</p><Link to="/shop" className="btn btn-primary">Start Shopping</Link></>
            }
          </div>
        )}
      </div>
    </div>
  );
}
